/** 家长预览弹窗：按模块登记表（modules.tsx）找预览组件，对应 iOS ActivityPreview */
import type { Content } from "../../core";
import { EmptyHint, Sheet, SheetBody, SheetHeader } from "../../ui";
import { activityName } from "./activity";
import { webModule } from "./modules";

export function PreviewSheet({ content, open, onClose }: { content: Content; open: boolean; onClose: () => void }) {
  return (
    <Sheet open={open} onClose={onClose} width={760} label="预览">
      <SheetHeader title={`预览 · ${content.title}`} onClose={onClose} />
      <SheetBody>
        <PreviewBody content={content} />
      </SheetBody>
    </Sheet>
  );
}

export function PreviewBody({ content }: { content: Content }) {
  const P = webModule(content.activityType).Preview;
  return P ? <P content={content} /> : <EmptyHint text={`暂不支持预览「${activityName(content.activityType)}」`} />;
}
